import Commons from '../../Services/Common/Common';

/**
 * 회원정보 모달 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *
 * - mapper: API payload 생성 규칙
 *   - mapParamsBySchema(mapper, context)로 조회 파라미터를 만듬
 *   - context에는 userInfo, search 등이 들어옴
 */
export const MemberInfoModal_Schema = {
  fields: {
    id: { initial: '', label: '아이디' },
    name: { initial: '', label: '성명' },
    depNm1: { initial: '', label: '부서1' },
    depNm2: { initial: '', label: '부서2' },
    depNm3: { initial: '', label: '부서3' },
    depNm4: { initial: '', label: '부서4' },
    position: { initial: '', label: '직책' },
  },

  mapper: {
    // 회원정보 조회
    search1: {
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || '') || '',
      CoCd: (_, context) => Commons.EncryptAES(context.userInfo?.coCd || '') || '',
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || '') || '',
      SearchText: (_, context) => Commons.EncryptAES(context.search?.searchText || '') || '',
    },
  },
};
